
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view-pi",
      function () {
        return require("private-next-pages/view-pi.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view-pi"])
      });
    }
  